//Dropdown functionality
const $window = $(window);
const activeClass = 'is-active';
let isTouch = (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0));
let $submenuTrigger = $('.js-dropdown-trigger');

$window.on('load resize', function() {
	if (isTouch == false) {
		$('body').addClass('is-not-touch-device');
	} else {
		$('body').removeClass('is-not-touch-device')
	}

	if ($window.width() > 1024 && !isTouch) {
		if ($submenuTrigger.hasClass(activeClass)) {
			$submenuTrigger.removeClass(activeClass)
				.parent()
				.removeClass(activeClass)
		}
	}

	if ($window.width() > 767) {
		if ($('.js-dropdown-trigger').hasClass(activeClass)) {
			$('.js-dropdown-trigger').removeClass(activeClass)
				.next()
				.slideUp()
					.parent()
					.removeClass(activeClass)
		}
	}
})

//Closing the dropdown if the click it's not on it's trigger
$(document).click(function(e) {
	var $target = $(e.target)

	if (isTouch && !$target.closest($submenuTrigger).length) {
		$submenuTrigger.removeClass(activeClass)
			.parent()
			.removeClass(activeClass)
	}
})

$submenuTrigger.on('click', function(e) {
	const $this = $(this);

	if ($window.width() < 1025 || isTouch) {
		e.preventDefault();

		if (!$this.hasClass(activeClass)) {
			$('.js-dropdown-trigger').removeClass(activeClass)
				.next()
				.slideUp()
					.parent()
					.removeClass(activeClass)
		}

		$this.toggleClass(activeClass)
			.next()
			.slideToggle()
				.parent()
				.toggleClass(activeClass)
	}
})

// blog category dropdown code

function printSelectedItem(){
	var e=document.getElementById('categoryDropdown');
	var selectedItem=e.options[e.selectedIndex].value;
	document.getElementById("categoryHeader").innerHTML = selectedItem;
}

printSelectedItem();
